import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Organization, OrganizationBranding } from '../models/organization';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private platformId = this.userService.user.appInstance.platform;
  private organizationRoute = 'items/organization';

  constructor(private http: HttpClient, private userService: UserService) {}

  getAll = () => {
    this.http
      .get(
        environment.directusBaseUrl +
          'items/organization?fields=*.*' +
          '&filter[status][_eq]=published' +
          `&filter[platform][platform_id][_eq]=${this.platformId}`,
      )
      .toPromise()
      .then((result: { data: Organization[] }) => result.data);
  };

  async getByAreaIds(areaIds: string[], parent: boolean) {
    if (areaIds.length < 1) {
      throw Error('Missing area ids');
    }
    const fields =
      'id,slug,branding.greeting,branding.logo,branding.primary_color,branding.secondary_color,branding.tertiary_color,area.id,translations.*,enableSeutuluotsiAnnouncements';
    const sort = 'translations.name';
    const filters: any = { _and: [] };
    let areaFilter = {};
    if (parent) {
      areaFilter = { area: { parent: { id: { _in: areaIds } } } };
    } else {
      areaFilter = { area: { id: { _in: areaIds } } };
    }
    filters._and.push(
      {
        status: { _eq: 'published' },
      },
      {
        platform: { platform_id: { _eq: this.platformId } },
      },
      areaFilter,
    );
    const url = new URL(environment.directusBaseUrl + this.organizationRoute);
    url.searchParams.set('filter', JSON.stringify(filters));
    url.searchParams.set('fields', fields);
    url.searchParams.set('sort', sort);
    return this.http
      .get(url.href)
      .toPromise()
      .then((response: { data: Organization[] }) => response.data);
  }

  getBySlug = (slug: string) =>
    this.http
      .get(
        environment.directusBaseUrl +
          'items/organization?fields=*.*' +
          '&filter[status][_eq]=published' +
          `&filter[slug][_eq]=${slug}`,
      )
      .toPromise()
      .then((result: { data: Organization[] }) => {
        let organizations = result.data;
        if (organizations.length > 0) return organizations[0];
        else return null;
      });

  getAllTypes = () =>
    this.http
      .get(
        environment.directusBaseUrl +
          'items/organization?fields=type.type' +
          '&filter[status][_eq]=published' +
          `&filter[platform][platform_id][_eq]=${this.platformId}`,
      )
      .toPromise()
      .then((result: { data: Organization[] }) => result.data.map((org) => org.type));

  getBySearch = (searchQuery) =>
    this.http
      .get(
        environment.directusBaseUrl +
          'items/organization?fields=*.*' +
          '&filter[status][_eq]=published' +
          `&filter[platform][platform_id][_eq]=${this.platformId}` +
          `&search=${searchQuery}` +
          `&limit=15`,
      )
      .toPromise()
      .then((result: { data: Organization[] }) => result.data);

  getBranding = (organizationId: string) =>
    this.http
      .get(
        environment.directusBaseUrl + `items/organization/${organizationId}` + '?fields=branding.*',
      )
      .toPromise()
      .then((result: { data: { branding: OrganizationBranding } }) => {
        const branding = result.data.branding;
        return branding;
      });

  getById = (orgId: string) =>
    this.http
      .get(environment.directusBaseUrl + `items/organization/${orgId}?fields=*.*`)
      .toPromise()
      .then((result: { data: Organization }) => result.data);
}
